import { Paper } from "@mui/material";
import styled from "styled-components";

import Menu from "./sidebar components/Menu";
import { colors } from "../../pages/css components/Style";

const Wrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  // padding: 0 10px 10px;
  gap: 10px;
  transition: 0.2s ease;
  overflow: hidden;
  border-radius: 0;
  box-shadow: 5px 0 5px -5px rgba(35, 37, 38, 0.15);
`;

export default function Sidebar({
  sidebarState,
  onMouseEnter,
  onMouseLeave,
  selectedMenu,
  setSelectedMenu,
}) {
  return (
    <Wrapper
      elevation={0}
      style={{
        width: sidebarState.open ? "230px" : "80px",
        background: colors.sprintexBlue,
      }}
    >
      <Menu
        sidebarState={sidebarState}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </Wrapper>
  );
}
